import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { ImporterService } from 'src/app/core/services/importer.service';
import { DmsService } from 'src/app/core/services/dms.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-settings-features',
  templateUrl: './settings-features.component.html',
  styleUrls: ['./settings-features.component.css'],
})
export class SettingsFeaturesComponent implements OnInit {
  @Input() panoramaEnabled: any;
  @Input() user: any;
  @Input() features: any;
  @Input() currentUser: any;
  @Input() darkBgMode: boolean;
  @Input() isUserFeatures: boolean = false;
  @Input() isClientFeatures: boolean = false;
  @Input() selectedSettingId: string;
  @Output() sendFeature = new EventEmitter<Object>();
  @Output() message = new EventEmitter<Object>();
  @Input() vehicleFeatures: any;
  @Input() markersEnabled: boolean = false;
  @Input() clientId: string;
  @Input() client: any;

  isSimpleUser: boolean = false;
  carConfConnected: boolean = false;
  instagramDMSConnected: boolean = false;
  instagramCatchDMSConnected: boolean = false;

  constructor(
    private importerService: ImporterService,
    private dmsService: DmsService
  ) {}

  ngOnInit(): void {
    console.log(this.features)
    this.user?.role.type === 'simple'
      ? (this.isSimpleUser = true)
      : (this.isSimpleUser = false);
    if (this.isUserFeatures) {
      this.loadUserImporters();
      this.loadUserAndClientDms(this.user.id, this.user.clientId);
    }
    if (this.isClientFeatures) {
      this.loadClientDms(this.clientId);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.features) {
      if (this.isUserFeatures) {
        this.loadUserImporters();
        this.loadUserAndClientDms(this.user.id, this.user.clientId);
      }
      if (this.isClientFeatures) {
        this.loadClientDms(this.clientId);
      }
    }
  }

  loadUserImporters() {
    this.importerService
      .getUserImporters(this.user.id, this.selectedSettingId)
      .subscribe((res) => {
        const carConfImporterExists = res.some((importer) => {
          return importer.importer.requiredFeatures.some(
            (feature) => feature.name === 'carconfImport'
          );
        });
        this.carConfConnected = carConfImporterExists;
      });
  }

  loadClientDms(clientId: string) {
    this.dmsService
      .getClientDMS(clientId)
      .subscribe((res) => this.processClientDmsResponse(res));
  }

  loadUserAndClientDms(userId: string, clientId: string) {
    const userDms$ = this.dmsService.getUserDMS(userId, this.selectedSettingId);
    const clientDms$ = this.dmsService.getClientDMS(clientId);

    forkJoin([userDms$, clientDms$]).subscribe(
      ([userDmsRes, clientDmsRes]) => {
        this.processUserDmsResponse(userDmsRes);

        if (!this.instagramDMSConnected) {
          this.processClientDmsResponse(clientDmsRes);
        }
      },
      (error) => {}
    );
  }

  processUserDmsResponse(res: any) {
    this.instagramCatchDMSConnected = res.some((dms) => {
      return dms.dms.requiredFeatures.some(
        (feature) => feature.name === 'instagramCatch'
      );
    });

    this.instagramDMSConnected = res.some((dms) => {
      return dms.dms.requiredFeatures.some(
        (feature) => feature.name === 'instagram'
      );
    });
  }

  processClientDmsResponse(res: any) {
    this.instagramDMSConnected = res.some((dms) => {
      return dms.dms.requiredFeatures.some(
        (feature) => feature.name === 'instagram'
      );
    });
  }

  patchFeature(event, feature) {
    this.sendFeature.emit({ event, feature });
  }

  showMessage(feature) {
    this.message.emit(feature);
  }

  isFeatureVisible(featureName: string) {
    let isVisible = true;

    switch (featureName) {
      case 'panorama_front':
      case 'panorama_back':
        isVisible = !!(!this.isSimpleUser && this.panoramaEnabled);
        break;
      case 'markers':
        isVisible = !!(!this.isSimpleUser && this.markersEnabled);
        break;
      case 'carconfImport':
        isVisible = !!(!this.isSimpleUser && this.carConfConnected);
        break;
      case 'instagramCatch':
        isVisible = !!(!this.isSimpleUser && this.instagramCatchDMSConnected);
        break;
      case 'instagram':
        isVisible = !!(!this.isSimpleUser && this.instagramDMSConnected);
        break;
      case 'pro':
        isVisible = !!(this.user?.usePremium || this.client?.usePremium);
        break;
      case 'premium360':
      case 'premiumVideo':
        isVisible = !!(!this.isSimpleUser && (this.user?.usePremium || this.client?.usePremium));
        break;
      default:
        break;
    }

    return isVisible;
  }
}
